import {Component, Input, OnInit} from '@angular/core';
import {PasswordStrengthComponent} from '../ngx-material-password-strength/password-strength.component';

@Component({
  selector: 'ngx-material-password-strength-info',
  template: `
    <mat-card>
      <mat-card-content fxLayout="column" fxLayoutAlign="start">

        <div class="info-row">
          <div *ngIf="passwordComponent.containAtLeastOneLowerCaseLetter; then done else error">
          </div>
          <ng-template #done>
            <mat-icon color="primary">done</mat-icon>
          </ng-template>
          <ng-template #error>
            <mat-icon color="warn">error</mat-icon>
          </ng-template>
          <div>
            <p>contains at least one lower character</p>
          </div>
        </div>

        <div class="info-row">
          <div *ngIf="passwordComponent.containAtLeastOneUpperCaseLetter; then done else error">
          </div>
          <ng-template #done>
            <mat-icon color="primary">done</mat-icon>
          </ng-template>
          <ng-template #error>
            <mat-icon color="warn">error</mat-icon>
          </ng-template>
          <div>
            <p>contains at least one upper character</p>
          </div>
        </div>

        <div class="info-row">
          <div *ngIf="passwordComponent.containAtLeastOneDigit; then done else error">
          </div>
          <ng-template #done>
            <mat-icon color="primary">done</mat-icon>
          </ng-template>
          <ng-template #error>
            <mat-icon color="warn">error</mat-icon>
          </ng-template>
          <div>
            <p>contains at least one digit character</p>
          </div>
        </div>

        <div class="info-row">
          <div *ngIf="passwordComponent.containAtLeastOneSpecialChar; then done else error">
          </div>
          <ng-template #done>
            <mat-icon color="primary">done</mat-icon>
          </ng-template>
          <ng-template #error>
            <mat-icon color="warn">error</mat-icon>
          </ng-template>
          <div>
            <p>contains at least one special character</p>
          </div>
        </div>

        <div class="info-row">
          <div *ngIf="passwordComponent.containAtLeastEightChars; then done else error">
          </div>
          <ng-template #done>
            <mat-icon color="primary">done</mat-icon>
          </ng-template>
          <ng-template #error>
            <mat-icon color="warn">error</mat-icon>
          </ng-template>
          <div>
            <p>contains at least eight characters</p>
          </div>
        </div>

        <div class="info-row">
          <div *ngIf="passwordComponent.strength === 100; then done else error">
          </div>
          <ng-template #done>
            <mat-icon color="primary">done</mat-icon>
          </ng-template>
          <ng-template #error>
            <mat-icon color="warn">error</mat-icon>
          </ng-template>
          <div>
            <p>Password's strength = {{passwordComponent.strength}} %100</p>
          </div>
        </div>

      </mat-card-content>
    </mat-card>
  `,
  styles: [`
    mat-card{flex-direction:row;place-content:stretch center;flex:1 1 0%}mat-card,mat-card mat-card-content{box-sizing:border-box;display:flex;align-items:stretch}mat-card mat-card-content{flex-direction:column;max-width:100%;place-content:stretch flex-start}mat-card mat-card-content mat-icon{margin-right:10px}mat-card mat-card-content .info-row{flex-direction:row;box-sizing:border-box;display:flex}
  `]
})
export class NgxMaterialPasswordStrengthInfoComponent implements OnInit {

  @Input()
  passwordComponent: PasswordStrengthComponent;

  constructor() {
  }

  ngOnInit() {
  }

}
